import api from '@/libs/axios'

export default {
  getCompanies: () => api.get('/system/companies/'),
  getCompanyById: id => api.get(`/system/companies/${id}`),
  editCompany: form => api.patch(`/system/companies/${form.id}`, form),
  createCompany: form => api.post('/system/companies', form),
  deleteCompanies: array => api.delete('/system/companies', array),
}
